import { z } from 'zod';

export const deliverySchema = z.object({
  id: z.string(),
  endpointId: z.string(),
  endpointName: z.string().nullable(),
  eventId: z.string(),
  attempt: z.number(),
  status: z.enum(['DELIVERED', 'FAILED']),
  responseStatus: z.number().nullable(),
  responseBody: z.string().nullable(),
  error: z.string().nullable(),
  durationMs: z.number(),
  requestedAt: z.string(),
  respondedAt: z.string().nullable(),
  /** Sólo en el listado global (`/bo/webhooks/deliveries`). */
  appId: z.string().optional(),
  appName: z.string().optional(),
  eventType: z.string().optional(),
});
export type WebhookDelivery = z.infer<typeof deliverySchema>;

export const endpointHealthSchema = z.object({
  endpointId: z.string(),
  appId: z.string(),
  appName: z.string(),
  name: z.string(),
  url: z.string(),
  disabledAt: z.string().nullable(),
  delivered: z.number(),
  failed: z.number(),
  lastStatus: z.enum(['DELIVERED', 'FAILED']).nullable(),
  lastRequestedAt: z.string().nullable(),
  lastError: z.string().nullable(),
});
export type EndpointHealth = z.infer<typeof endpointHealthSchema>;

export const webhooksOverviewSchema = z.object({
  window: z.enum(['1h', '6h', '24h', '7d']),
  appId: z.string().nullable(),
  delivered: z.number(),
  failed: z.number(),
  failureRate: z.number().nullable(),
  failing: z.array(endpointHealthSchema),
  endpoints: z.array(endpointHealthSchema),
  generatedAt: z.string(),
});
export type WebhooksOverview = z.infer<typeof webhooksOverviewSchema>;

export const webhooksSeriesSchema = z.object({
  window: z.enum(['1h', '6h', '24h', '7d']),
  bucketSeconds: z.number(),
  points: z.array(z.object({ t: z.string(), delivered: z.number(), failed: z.number() })),
});
export type WebhooksSeries = z.infer<typeof webhooksSeriesSchema>;

export const webhookSchema = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
  events: z.array(z.string()),
  managedBy: z.string().nullable(),
  disabledAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  lastDelivery: deliverySchema.nullable(),
  counts24h: z.object({ delivered: z.number(), failed: z.number() }),
});
export type Webhook = z.infer<typeof webhookSchema>;
